// ============================================================
// PlaybackContext
// ============================================================

import React, { createContext, useContext, useEffect, useState } from 'react';
import { playbackEngine, type PlaybackCursor } from '../../core/playbackEngine';

interface PlaybackContextValue {
  cursor: PlaybackCursor | null;
}

const PlaybackContext = createContext<PlaybackContextValue>({ cursor: null });

export function PlaybackProvider({ children }: { children: React.ReactNode }) {
  const [cursor, setCursor] = useState<PlaybackCursor | null>(null);

  useEffect(() => {
    const unsubscribe = playbackEngine.addCursorCallback(setCursor);
    return () => {
      unsubscribe();
      setCursor(null);
    };
  }, []);

  return (
    <PlaybackContext.Provider value={{ cursor }}>
      {children}
    </PlaybackContext.Provider>
  );
}

/** Returns the full cursor object — use when you need chordIdx. */
export function usePlaybackCursor(): PlaybackCursor | null {
  return useContext(PlaybackContext).cursor;
}

/** True when this bar contains the currently playing chord. */
export function useIsBarPlaying(sectionIdx: number, barIdx: number): boolean {
  const { cursor } = useContext(PlaybackContext);
  if (!cursor) return false;
  return cursor.sectionIdx === sectionIdx && cursor.barIdx === barIdx;
}